import { List, useDataGrid } from "@refinedev/mui";
import React from "react";

import { GridRowSelectionModel } from "@mui/x-data-grid";

import { useNavigate } from "react-router-dom";

import { ITeacher } from "./interfaces";
import { Button } from "@mui/material";
import { SearchToolbar, DataGridPanel, ListPageHeader } from "components/list";
import { teachersColumns } from "./components/teachersColumns";
import { teachersSearchFields } from "./components/teachersSearchFields";

export const TeacherList: React.FC = () => {
    const { dataGridProps, setFilters, filters, tableQueryResult } =
        useDataGrid<ITeacher>({
            initialCurrent: 1,
            initialPageSize: 20,
        });

    const [rowSelectionModel, setRowSelectionModel] = React.useState<GridRowSelectionModel>([]);
    const navigate = useNavigate();

    // refine의 rowCount는 fetch 중 잠깐 0으로 떨어져 "전체 0건"이 깜빡인다.
    // 로딩이 아닐 때의 마지막 값을 유지해 표시한다.
    const lastRowCountRef = React.useRef<number | undefined>(undefined);
    if (!dataGridProps.loading && typeof dataGridProps.rowCount === "number") {
        lastRowCountRef.current = dataGridProps.rowCount;
    }

    return (
        <List
            breadcrumb={<></>}
            headerButtons={({ defaultButtons }) => (
                <>
                {defaultButtons}
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => {
                        navigate("/alarms/create", { state: { ids: rowSelectionModel }});
                    }}
                >
                    푸시알림 전송
                </Button>
                </>
            )}
        >
            <ListPageHeader
                count={lastRowCountRef.current}
                description="아이러빗에 가입한 교사·시설 관리자 회원 목록"
            />

            <SearchToolbar
                fields={teachersSearchFields}
                filters={filters}
                setFilters={setFilters}
            />

            <DataGridPanel
                {...dataGridProps}
                columns={teachersColumns}
                isError={tableQueryResult.isError}
                errorMessage="교사 목록을 불러오지 못했습니다."
                emptyMessage="조건에 맞는 교사가 없습니다."
                pageSizeOptions={[10, 20, 30, 50, 100]}
                disableColumnFilter
                filterModel={undefined}
                checkboxSelection
                onRowSelectionModelChange={(model) => setRowSelectionModel(model)}
                rowSelectionModel={rowSelectionModel}
                getRowShowPath={(row) => `/teachers/show/${row.id}`}
            />
        </List>
    );
};
